module.exports = __webpack_public_path__ + "img/previewImg4.2bb50716.png";